import React from 'react'
import VerticalDetails from '../components/GenericVerticalComponents/VerticalDetails'
import { HICon } from '../components/GenericVerticalComponents/ProductUseCases';
import { base, section } from 'framer-motion/client';
import { Helmet } from 'react-helmet-async';
import siteConfig from '../configuration/siteConfiguration';

const baseImageUrl = `${siteConfig.assetBaseUrl}/icons/healthcare`;
const baseImageUrl1 = `${siteConfig.assetBaseUrl}/icons/legal/what-indiaverdict-does/default-state/`;

const cardData = [
    {
        id: 1,
        title: 'Fusion Diagnostics & Clinical Intelligence',
        icon: `${baseImageUrl}/fusion-diagnostics-icon.png`,
    },
    {
        id: 2,
        title: 'MedVault • Rhoda - Medical Record Vault',
        icon: `${baseImageUrl}/medvault-icon.png`,
    },
    {
        id: 3,
        title: 'AI-Assisted Drug Discovery & Translational Research',
        icon: `${baseImageUrl}/drug-discovery-research-icon.png`,
    },
    {
        id: 4,
        title: 'Consent, Governance & Auditability',
        icon: `${baseImageUrl}/consent-governance-icon.png`,
    },
    {
        id: 5,
        title: 'Clinical & Research Knowledge Management',
        icon: `${baseImageUrl}/knowledge-management-icon.png`,
    },
    {
        id: 6,
        title: 'Analytics & Insights Dashboards',
        icon: `${baseImageUrl}/analytics-dashboards-icon.png`,
    },
];

const benefits = [
    {
        title: "10x-15x faster diagnostics",
        icon: "/images/countdown2.svg"
    },
    {
        title: "70% increase in research productivity",
        icon: "/images/sidebaricons.svg"
    },
    {
        title: "AI-powered drug discovery",
        icon: "/images/drug-discovery.png"
    }
];

const healthCareProdStats = [
    { value: "Millions", description: "of medical records unified, indexed, and structured for longitudinal insight" },
    { value: "80% +", description: "reuse of governed AI blocks across clinical, research, and public health workflows" },
    { value: "10-15x", description: "faster access to unified patient records and clinical summaries" },
    { value: "70%", description: "reduction in clinician time spent navigating fragmented medical data" },
    { value: "95%+", description: "accuracy in structured extraction from complex medical records" },
    { value: "30-50%", description: "reduction in operational and compliance risk through audit-ready intelligence" },
];

const useCases = [
    {
        icon: <HICon icon="ai-powered-legal-research.svg" />,
        title: 'Longitudinal Patient Intelligence',
        summary: 'Unify fragmented medical records into a single patient view.',
        description: `Cognitva Health brings together patient information scattered across reports, laboratory systems, imaging, discharge summaries, and clinical notes into a unified longitudinal view. By organizing medical history over time, the platform helps clinicians and care teams understand patient context more clearly-supporting better continuity of care without replacing existing hospital systems.`
    },
    {
        icon: <HICon icon="smart-client--matter-management.svg" />,
        title: 'Fusion Diagnostics',
        summary: 'Connect insights across labs, imaging, and clinical observations.',
        description: `Cognitva Health enables fusion diagnostics by correlating information across multiple diagnostic modalities. This helps clinicians see meaningful relationships across labs, imaging, and clinical data, supporting more informed diagnostic reasoning in complex cases while maintaining transparency and clinical oversight.`
    },
    {
        icon: <HICon icon="ai-driven-knowledge-management.svg" />,
        title: 'Clinician Time Reduction',
        summary: 'Reduce documentation burden with structured summaries.',
        description: `Cognitva Health reduces the cognitive and administrative burden on clinicians by transforming unstructured medical records into concise, structured summaries. Explainable insights help care teams quickly focus on what matters most, enabling faster clinical interpretation without sacrificing trust or accountability.`
    },
    {
        icon: <HICon icon="analytics--insights-dashboards.svg" />,
        title: 'Governance-Ready Healthcare AI',
        summary: 'Deploy AI with consent, auditability, and traceability built in.',
        description: `Designed for regulated healthcare environments, Cognitva Health embeds governance, consent awareness, and auditability directly into its intelligence layer. This enables hospitals and public health systems to deploy AI responsibly, with clear traceability and operational visibility across both clinical and population-scale use cases.`
    },
    {
        icon: <HICon icon="role-play--virtual-courtroom-simulation.svg" />,
        title: 'AI-Assisted Drug Discovery & Research',
        summary: 'Support compliant discovery and translational research workflows.',
        description: 'Cognitva Health supports drug discovery and translational research by assisting researchers with hypothesis evaluation, early validation, and structured insight generation. Built for regulated scientific environments, the platform emphasizes explainability and compliance, enabling confident research decisions from discovery through early-stage development.'
    },
];


export default function HealthCareProducts() {
    return (
        <>
            <Helmet>
                <title>CIP™ - HealthCare</title>
                <meta name="description" content="AI-powered fusion diagnostics, longitudinal patient intelligence, and drug discovery copilots - built for hospitals, clinicians, researchers, healthcare systems, and governments." />
                <meta name="keywords" content="AI-powered fusion diagnostics, longitudinal patient intelligence, drug discovery copilots, healthcare AI, clinical decision support" />
                <link rel="canonical" href="https://www.cognitva.ai/cip" />
                <meta property="og:title" content="CIP™ - Cross-Industry Intelligence Platform" />
                <meta property="og:description" content="AI-powered fusion diagnostics, longitudinal patient intelligence, and drug discovery copilots - built for hospitals, clinicians, researchers, healthcare systems, and governments." />
                <meta property="og:url" content="https://www.cognitva.ai/cip" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://www.cognitva.ai/images/cip-logo.png" />
                <meta property="og:image:alt" content="CIP Logo" />
                <meta property="og:site_name" content="Cognitva Global Technologies Private Limited" />
            </Helmet>
            <div className='page_container'>
                <VerticalDetails
                    keyFeaturesCards={cardData}
                    mainSection={{
                        title: "COGNITVA CIP-HEALTHCARE",
                        subtitle: "Where Cognitva Health transforms care and research",
                        description: "AI-powered fusion diagnostics, longitudinal patient intelligence, and drug discovery copilots - built for hospitals, clinicians, researchers, healthcare systems, and governments.",
                        benefits: benefits
                    }}
                    productStats={healthCareProdStats}
                    productUseCases={{
                        sectionTitle: "WHAT COGNITVA CIP-HEALTHCARE DOES",
                        sectionSubtitle: "Use Cases We Solve",
                        useCases: useCases
                    }}
                    requestInfoTitle={<>Experience technology designed to strengthen healthcare<br />systems and simplify care, compliance, and coordination.</>}
                />
            </div>
        </>
    )
}
